
import Highlight from '../../../components/base/Highlight';

export default function BeginnerSafetyTips() {
  const tips = [
    {
      number: '01',
      icon: 'ri-money-dollar-circle-line',
      title: '少額から始める',
      description:
        '最初は5万円〜10万円程度の少額資金でスタート。慣れてから徐々に増やしていきましょう。',
      highlight: 'DMM FXなら最低4万円から取引可能',
    },
    {
      number: '02',
      icon: 'ri-line-chart-line',
      title: 'レバレッジは低めに',
      description:
        '初心者は3〜5倍程度の低レバレッジから。高レバレッジは利益も大きいですがリスクも高まります。',
      highlight: '最大25倍まで可能ですが、まずは低めで',
    },
    {
      number: '03',
      icon: 'ri-shield-line',
      title: '損切りルールを決める',
      description:
        '損失が一定額に達したら必ず決済するルールを設定。感情的な判断を避けられます。',
      highlight: '例：資金の2%の損失で損切り',
    },
    {
      number: '04',
      icon: 'ri-book-open-line',
      title: 'デモ取引で練習',
      description:
        '実際のお金を使う前に、デモ取引で操作方法や取引の流れを体験しましょう。',
      highlight: 'DMM FXは無料でデモ取引が可能',
    },
    {
      number: '05',
      icon: 'ri-time-line',
      title: '余裕資金で取引',
      description:
        '生活費や貯金には手をつけず、失っても生活に影響のない余裕資金のみで取引してください。',
      highlight: '絶対に借金をして取引しない',
    },
    {
      number: '06',
      icon: 'ri-graduation-cap-line',
      title: '継続的に学習',
      description:
        '経済ニュースやFXの基礎知識を学び続けることで、リスクを減らし利益を増やせます。',
      highlight: 'DMM FXの学習コンテンツを活用',
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <Highlight variant="underline" color="red">初心者が安全に始める6つのポイント</Highlight>
          </h2>
          <p className="text-lg text-gray-600">
            これらのルールを守れば、リスクを最小限に抑えられます
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {tips.map((tip, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all relative overflow-hidden"
            >
              <div className="absolute top-4 right-4 text-6xl font-bold text-teal-50">
                {tip.number}
              </div>
              <div className="relative z-10">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${tip.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {index === 0 || index === 1 || index === 2 ? (
                    <Highlight variant="marker" color="red">{tip.title}</Highlight>
                  ) : (
                    tip.title
                  )}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm mb-4">
                  {index === 0 ? (
                    <>
                      最初は<Highlight variant="bold" color="red">5万円〜10万円</Highlight>程度の少額資金でスタート。慣れてから徐々に増やしていきましょう。
                    </>
                  ) : index === 1 ? (
                    <>
                      初心者は<Highlight variant="bold" color="red">3〜5倍</Highlight>程度の低レバレッジから。高レバレッジは利益も大きいですがリスクも高まります。
                    </>
                  ) : index === 2 ? (
                    <>
                      損失が一定額に達したら必ず決済するルールを設定。感情的な判断を避けられます。
                    </>
                  ) : (
                    tip.description
                  )}
                </p>
                <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-lg p-3 border-l-4 border-teal-500">
                  <p className="text-xs text-teal-700 font-semibold">
                    {index === 2 ? (
                      <>
                        例：資金の<Highlight variant="bold" color="red">2%</Highlight>の損失で損切り
                      </>
                    ) : (
                      tip.highlight
                    )}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl p-8 border-l-4 border-amber-500">
          <div className="flex items-start gap-4">
            <i className="ri-lightbulb-line text-4xl text-amber-600 flex-shrink-0"></i>
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                安全に取引するための心構え
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                FXは「一攫千金」を狙うギャンブルではなく、知識と経験を積み重ねて利益を出していく投資です。最初から大きな利益を狙わず、<Highlight variant="marker" color="red">少額から始めて徐々に慣れていく</Highlight>ことが成功への近道です。
              </p>
              <p className="text-gray-700 leading-relaxed">
                また、損失が出ても冷静に対処できるよう、<Highlight variant="marker" color="red">余裕資金のみで取引</Highlight>することが絶対条件です。生活費や貯金には絶対に手をつけないでください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
